export { IntegrationsDetail } from './details'
